import localforage from 'localforage';

import { decrypt, encrypt } from './encryption';

import type { StateStorage } from 'zustand/middleware';

export function createEncryptedStorage(): StateStorage {
    return {
        getItem: async (name: string): Promise<string | null> => {
            try {
                const encryptedValue = await localforage.getItem<string>(name);

                if (encryptedValue) {
                    try {
                        const decryptedValue = await decrypt(encryptedValue);
                        return decryptedValue;
                    } catch (decryptError) {
                        globalThis.window?.telemetryLogger?.error(
                            'Error decrypting value:',
                            decryptError,
                        );
                        return null;
                    }
                }

                return null;
            } catch (error) {
                globalThis.window?.telemetryLogger?.error(
                    'Error retrieving from storage:',
                    error,
                );
                return null;
            }
        },

        setItem: async (name: string, value: string): Promise<void> => {
            try {
                const encryptedValue = await encrypt(value);
                await localforage.setItem(name, encryptedValue);
            } catch (error) {
                globalThis.window?.telemetryLogger?.error(
                    'Error saving to storage:',
                    error,
                );
                throw error;
            }
        },

        removeItem: async (name: string): Promise<void> => {
            try {
                await localforage.removeItem(name);
            } catch (error) {
                globalThis.window?.telemetryLogger?.error(
                    'Error removing from storage:',
                    error,
                );
                throw error;
            }
        },
    };
}

export const encryptedStorage = createEncryptedStorage();
